import { useEffect } from 'react';
import L from 'leaflet';

const COL = { SW: '#8b5a2b', RW: '#06b6d4', MW: '#78716c' };
const view = () => window.__gissMapView?.()?.m;
export const fitPreview = (F) => { const m = view(); if (m && F?.length) m.fitBounds(L.latLngBounds(F.map((f) => [f.lat, f.lon])), { paddingTopLeft: [window.innerWidth > 900 ? 460 : 20, 40], paddingBottomRight: [30, window.innerWidth > 700 ? 40 : Math.round(window.innerHeight * 0.62)], maxZoom: 19 }); };

// imported network drawn on the main map before the project is created (removed when the preview closes)
export function useNetPreview(D) {
  useEffect(() => {
    const m = view();
    if (!m || !D?.F?.length) return undefined;
    if (!m.getPane('niPrev')) m.createPane('niPrev').style.zIndex = 640;
    const byK = Object.fromEntries(D.F.map((f) => [f.k, f])), ll = (x) => (typeof x === 'string' ? [byK[x].lat, byK[x].lon] : x), pane = 'niPrev';
    const g = L.layerGroup().addTo(m);
    D.P.forEach((p) => {
      const pts = (p.pts || [p.a, p.b]).map(ll), miss = p.sug?.d != null;
      g.addLayer(L.polyline(pts, { pane, color: miss ? '#f97316' : COL[p.sys] || '#2563eb', weight: 4, opacity: 0.9, dashArray: miss ? '7 6' : null, className: 'ni-prev-line' }).bindTooltip(`${p.name}${p.d && !miss ? ` · DN ${p.d}` : ''}`));
    });
    D.F.forEach((f) => {
      const end = f.hyd?.out || f.type === 'source';
      g.addLayer(L.circleMarker([f.lat, f.lon], { pane, radius: end ? 7 : 4, color: end ? '#16a34a' : f.sug ? '#f97316' : '#0f4c5c', weight: 2, fillColor: '#fff', fillOpacity: 0.9, className: 'ni-prev-node' }).bindTooltip(f.name));
    });
    fitPreview(D.F);
    return () => g.remove();
  }, [D]);
}
